/**
 * Lake Charles Privacy Policy Page
 *
 * Simple wrapper that imports the parameterized PrivacyPolicyPage from city-landing-core
 * and passes Lake Charles-specific configuration.
 */

import React from 'react';
import { PrivacyPolicyPage } from '@core';
import lakeCharlesConfig from '../city.config';

export function LakeCharlesPrivacyPolicyPage() {
  return (
    <PrivacyPolicyPage
      cityName={lakeCharlesConfig.identity.cityName}
      stateName={lakeCharlesConfig.identity.stateName}
      companyName="ToolboxLogic"
      // contactEmail="privacy@toolboxlogic.com"
      effectiveDate="November 22, 2024"
      cityDomain="lakecharles.toolboxlogic.com"
    />
  );
}
